import { cleanupText } from "@/core/utils/string-utils";

export function cleanupPrompt(prompt: string) {
  return cleanupText(prompt);
}
